import { render } from "./customizeViewGoodsExport.vue?vue&type=template&id=3c96667a&ts=true"
import script from "./customizeViewGoodsExport.vue?vue&type=script&lang=ts"
export * from "./customizeViewGoodsExport.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__